import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWeightTrainingNormalMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.35 15.66h-1.93v-2.41a1.17 1.17 0 00-1.17-1.17h-1.87a.86.86 0 00-.17 0v-1.39A1.17 1.17 0 0025 9.52h-1.83A1.17 1.17 0 0022 10.69v5H10v-5a1.17 1.17 0 00-1.18-1.17H7a1.17 1.17 0 00-1.17 1.17v1.42a1 1 0 00-.17 0H3.74a1.17 1.17 0 00-1.17 1.17v2.41H.63a.5.5 0 00-.5.5.51.51 0 00.5.5h1.94v2.61a1.17 1.17 0 001.17 1.17h1.87a1 1 0 00.17 0v1.52A1.17 1.17 0 007 23.09h1.82A1.17 1.17 0 0010 21.92v-5.26h12v5.26a1.17 1.17 0 001.17 1.17H25a1.17 1.17 0 001.17-1.17V20.4a.85.85 0 00.17 0h1.87a1.18 1.18 0 001.17-1.17v-2.57h1.93a.5.5 0 00.5-.5.5.5 0 00-.46-.5zM5.61 19.44H3.74a.18.18 0 01-.17-.17v-6a.17.17 0 01.17-.17h1.87a.17.17 0 01.17.17v6a.18.18 0 01-.17.17zM9 21.92a.16.16 0 01-.17.17H7a.17.17 0 01-.17-.17V10.69a.17.17 0 01.17-.17h1.82a.16.16 0 01.17.17zm16.22 0a.17.17 0 01-.17.17h-1.88a.16.16 0 01-.17-.17V10.69a.16.16 0 01.17-.17H25a.17.17 0 01.17.17v11.23zm3.21-2.65a.18.18 0 01-.17.17h-1.88a.17.17 0 01-.17-.17v-6a.16.16 0 01.17-.17h1.87a.17.17 0 01.17.17z"
  }));
});
SvgSportsWeightTrainingNormalMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgSportsWeightTrainingNormalMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWeightTrainingNormalMedium;